import { useTranslation } from "react-i18next";
import { useAppSelector } from "src/common/state/hooks";
import { getHelpDocsJwt } from "src/features/auth/state/authSlice";

const useOnboardingSteps = () => {
  const { t } = useTranslation();
  const helpDocsJwt = useAppSelector(getHelpDocsJwt);

  const generateHelpDocsUrl = () => {
    if (!helpDocsJwt) return "#";

    const url = new URL("https://wixar.helpdocs.io/login/jwt/token");
    url.searchParams.set("hd_jwt", helpDocsJwt);
    url.searchParams.set("forward", "/category/4df70tptd5-onboarding");
    url.searchParams.set(
      "suggestions",
      "category:4df70tptd5-onboarding,category:2qhlgg5ful-advanced-use",
    );

    return url.toString();
  };
  return {
    introOnboarding: [
      {
        selector: ".introOnboarding-step-1",
        content: () => (
          <div>
            <p className="pb-3">{t("onboardingtour.introOnboarding.step1")}</p>
            <a
              className="font-bold text-green-500 underline underline-offset-4 "
              target="_blank"
              rel="noopener noreferrer"
              href={generateHelpDocsUrl()}
            >
              {t("onboardingtour.introOnboarding.step1Bold")}
            </a>
          </div>
        ),
      },
      {
        selector: ".introOnboarding-step-2",
        content: t("onboardingtour.introOnboarding.step2"),
      },
      {
        selector: ".introOnboarding-step-3",
        content: t("onboardingtour.introOnboarding.step3"),
      },
      {
        selector: ".introOnboarding-step-4",
        content: t("onboardingtour.introOnboarding.step4"),
      },
      {
        selector: ".introOnboarding-step-5",
        content: t("onboardingtour.introOnboarding.step5"),
      },
      {
        selector: ".introOnboarding-step-6",
        content: t("onboardingtour.introOnboarding.step6"),
      },
    ],
    onboardingAboutModules: [
      {
        selector: ".onboardingAboutModules-step-1",
        content: t("onboardingtour.onboardingAboutModules.step1"),
      },
      {
        selector: ".onboardingAboutModules-step-2",
        content: t("onboardingtour.onboardingAboutModules.step2"),
      },
      {
        selector: ".onboardingAboutModules-step-3",
        content: t("onboardingtour.onboardingAboutModules.step3"),
      },
    ],
    assistantScenarIa: [
      {
        selector: ".assistantScenarIa-step-1",
        content: t("general.assistantScenarIa.coachmark.step1"),
      },
      {
        selector: ".assistantScenarIa-step-2",
        content: t("general.assistantScenarIa.coachmark.step2"),
      },
      {
        selector: ".assistantScenarIa-step-3",
        content: t("general.assistantScenarIa.coachmark.step3"),
      },
    ],
    graphFlowIntro: [
      {
        selector: ".graphFlowIntro-step-1",
        content: t("onboardingtour.graphFlowIntro.step1"),
      },
      {
        selector: ".graphFlowIntro-step-2",
        content: t("onboardingtour.graphFlowIntro.step2"),
      },
      {
        selector: ".graphFlowIntro-step-3",
        content: t("onboardingtour.graphFlowIntro.step3"),
      },
      {
        selector: ".graphFlowIntro-step-4",
        content: t("onboardingtour.graphFlowIntro.step4"),
      },
    ],
    onboardingHowToAddScene: [
      {
        selector: ".onboardingHowToAddScene-step-1",
        content: t("onboardingtour.onboardingHowToAddScene.step1"),
      },
      {
        selector: ".onboardingHowToAddScene-step-2",
        content: t("onboardingtour.onboardingHowToAddScene.step2"),
      },
      {
        selector: ".onboardingHowToAddScene-step-3",
        content: t("onboardingtour.onboardingHowToAddScene.step3"),
      },
      {
        selector: ".onboardingHowToAddScene-step-4",
        content: t("onboardingtour.onboardingHowToAddScene.step4"),
      },
      {
        selector: ".onboardingHowToAddScene-step-5",
        content: () => (
          <div>
            <p>{t("onboardingtour.onboardingHowToAddScene.step5")}</p>
            <p className="font-bold">{t("onboardingtour.onboardingHowToAddScene.step5Bold")}</p>
          </div>
        ),
      },
    ],
  };
};

export default useOnboardingSteps;
